<!-- 用户操作 -->
<template>
    <div>
        <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" :with-header="false" append-to-body center width="80%" top="2rem">
            <el-form size="mini" :show-message="false" label-width="120px" :model="sendDataInfo" ref="sendDataInfo">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="选择部门" prop="depId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                            <label slot="label" :style="$common.labelStyle('选择部门')" v-html="'选择部门'"></label>
                            <el-select v-model="sendDataInfo.depId" placeholder="请选择" clearable>
                                <el-option v-for="item in departmentList" :key="item.depId" :label="item.depName" :value="item.depId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="人员编码" prop="opmCode">
                            <label slot="label" :style="$common.labelStyle('人员编码')" v-html="'人员编码'"></label>
                            <el-input v-model.trim="sendDataInfo.opmCode" placeholder="请输入人员编码" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员名称" prop="opmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                            <label slot="label" :style="$common.labelStyle('人员名称')" v-html="'人员名称'"></label>
                            <el-input v-model.trim="sendDataInfo.opmName" placeholder="请输入人员名称" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="助记码" prop="opmMne">
                            <label slot="label" :style="$common.labelStyle('助记码')" v-html="'助记码'"></label>
                            <el-input v-model.trim="sendDataInfo.opmMne" placeholder="请输入人员名称" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="opmMobilenumber">
                            <label slot="label" :style="$common.labelStyle('手机号')" v-html="'手机号'"></label>
                            <el-input v-model.trim="sendDataInfo.opmMobilenumber" placeholder="请输入手机号" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号" prop="opmIdnumber">
                            <label slot="label" :style="$common.labelStyle('身份证号')" v-html="'身份证号'"></label>
                            <el-input v-model.trim="sendDataInfo.opmIdnumber" placeholder="请输入身份证号" maxlength="18">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证有效期" prop="opmPeriodDate">
                            <label slot="label" :style="$common.labelStyle('身份证有效期')" v-html="'身份证有效期'"></label>
                            <el-date-picker style="width: 100%;" value-format="timestamp" v-model="sendDataInfo.opmPeriodDate" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="登录账号" prop="opmAccount" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                            <label slot="label" :style="$common.labelStyle('登录账号')" v-html="'登录账号'"></label>
                            <el-input v-model.trim="sendDataInfo.opmAccount" :maxlength="$store.state.inputLength" placeholder="请输入登录账号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="登录密码" prop="opmPassword" v-if="dataActionBox.actionType == 0" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                            <label slot="label" :style="$common.labelStyle('登录密码')" v-html="'登录密码'"></label>
                            <el-input v-model.trim="sendDataInfo.opmPassword" :maxlength="$store.state.inputLength" placeholder="请输入登录密码"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="邮箱">
                            <label slot="label" :style="$common.labelStyle('邮箱')" v-html="'邮箱'"></label>
                            <el-input v-model.trim="sendDataInfo.opmEmail" :maxlength="$store.state.inputLength" placeholder="请输入联系邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="固话">
                            <label slot="label" :style="$common.labelStyle('固话')" v-html="'固话'"></label>
                            <el-input v-model.trim="sendDataInfo.opmTelenumber" :maxlength="$store.state.inputLength" placeholder="请输入联系固话"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="岗位" prop="opmJob">
                            <label slot="label" :style="$common.labelStyle('岗位')" v-html="'岗位'"></label>
                            <el-input v-model.trim="sendDataInfo.opmJob" placeholder="请输入岗位" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="班次" prop="banCi">
                            <label slot="label" :style="$common.labelStyle('班次')" v-html="'班次'"></label>
                            <el-input v-model.trim="sendDataInfo.banCi" placeholder="请输入班次" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="身份证正反面">
                        <label slot="label" :style="$common.labelStyle('身份证正反面')" v-html="'身份证正反面'"></label>
                        <el-upload ref="upload" :action="this.$store.getters.getConfig.requestUrl + '/upload/fileupload'" :headers="token" :file-list="fileList" list-type="picture-card" :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove" :on-success="handleSuccess">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>

                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="性别">
                            <label slot="label" :style="$common.labelStyle('性别')" v-html="'性别'"></label>
                            <el-radio-group v-model="sendDataInfo.opmSex">
                                <el-radio-button v-for="item in dictionariesData" :key="item.diId" :label="item.diValue">{{
                                    item.diValue }}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否收货人">
                            <label slot="label" :style="$common.labelStyle('是否收货人')" v-html="'是否收货人'"></label>
                            <el-radio-group v-model="sendDataInfo.opmDelivery" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否超管">
                            <label slot="label" :style="$common.labelStyle('是否超管')" v-html="'是否超管'"></label>
                            <el-radio-group v-model="sendDataInfo.opmAdmin" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否验收人">
                            <label slot="label" :style="$common.labelStyle('是否验收人')" v-html="'是否验收人'"></label>
                            <el-radio-group v-model="sendDataInfo.opmAcceptor" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否采购员">
                            <label slot="label" :style="$common.labelStyle('是否采购员')" v-html="'是否采购员'"></label>
                            <el-radio-group v-model="sendDataInfo.opmBuyer" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否收款人">
                            <label slot="label" :style="$common.labelStyle('是否收款人')" v-html="'是否收款人'"></label>
                            <el-radio-group v-model="sendDataInfo.opmCashier" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否配送员">
                            <label slot="label" :style="$common.labelStyle('是否配送员')" v-html="'是否配送员'"></label>
                            <el-radio-group v-model="sendDataInfo.opmDistributor" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否医师">
                            <label slot="label" :style="$common.labelStyle('是否医师')" v-html="'是否医师'"></label>
                            <el-radio-group v-model="sendDataInfo.opmDoctor" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否司机">
                            <label slot="label" :style="$common.labelStyle('是否司机')" v-html="'是否司机'"></label>
                            <el-radio-group v-model="sendDataInfo.opmDriver" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否部门主管">
                            <label slot="label" :style="$common.labelStyle('是否部门主管')" v-html="'是否部门主管'"></label>
                            <el-radio-group v-model="sendDataInfo.opmHeader" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否总经理">
                            <label slot="label" :style="$common.labelStyle('是否总经理')" v-html="'是否总经理'"></label>
                            <el-radio-group v-model="sendDataInfo.opmGm" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否保管员">
                            <label slot="label" :style="$common.labelStyle('是否保管员')" v-html="'是否保管员'"></label>
                            <el-radio-group v-model="sendDataInfo.opmKeeper" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否执业药师">
                            <label slot="label" :style="$common.labelStyle('是否执业药师')" v-html="'是否执业药师'"></label>
                            <el-radio-group v-model="sendDataInfo.opmPharmacist" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否复核人">
                            <label slot="label" :style="$common.labelStyle('是否复核人')" v-html="'是否复核人'"></label>
                            <el-radio-group v-model="sendDataInfo.opmReviewer" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否销售员">
                            <label slot="label" :style="$common.labelStyle('是否销售员')" v-html="'是否销售员'"></label>
                            <el-radio-group v-model="sendDataInfo.opmSalesperson" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否特药">
                            <label slot="label" :style="$common.labelStyle('是否特药')" v-html="'是否特药'"></label>
                            <el-radio-group v-model="sendDataInfo.opmSpc" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否价格特权">
                            <label slot="label" :style="$common.labelStyle('是否价格特权')" v-html="'是否价格特权'"></label>
                            <el-radio-group v-model="sendDataInfo.opmPrice" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否允许导出">
                            <label slot="label" :style="$common.labelStyle('是否允许导出')" v-html="'是否允许导出'"></label>
                            <el-radio-group v-model="sendDataInfo.opmExport" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否打印">
                            <label slot="label" :style="$common.labelStyle('是否打印')" v-html="'是否打印'"></label>
                            <el-radio-group v-model="sendDataInfo.isPrint" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否允许多设备登录">
                            <label slot="label" :style="$common.labelStyle('是否允许多设备登录')" v-html="'是否允许多设备登录'"></label>
                            <el-radio-group v-model="sendDataInfo.opmSitelogin" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否订单特权">
                            <label slot="label" :style="$common.labelStyle('是否订单特权')" v-html="'是否订单特权'"></label>
                            <el-radio-group v-model="sendDataInfo.opmOrder" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否展示流程">
                            <label slot="label" :style="$common.labelStyle('是否展示流程')" v-html="'是否展示流程'"></label>
                            <el-radio-group v-model="sendDataInfo.isShowFlow" size="mini">
                                <el-radio-button :label="0">否</el-radio-button>
                                <el-radio-button :label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancel">取消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
        </el-dialog>
        <el-drawer :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="100%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" :show-message="false" label-width="120px" :model="sendDataInfo" ref="sendDataInfo">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="选择部门" prop="depId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                    <label slot="label" :style="$common.labelStyle('选择部门')" v-html="'选择部门'"></label>
                                                    <el-select v-model="sendDataInfo.depId" placeholder="请选择" clearable>
                                                        <el-option v-for="item in departmentList" :key="item.depId" :label="item.depName" :value="item.depId">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="人员编码" prop="opmCode">
                                                    <label slot="label" :style="$common.labelStyle('人员编码')" v-html="'人员编码'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmCode" placeholder="请输入人员编码" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="人员名称" prop="opmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                    <label slot="label" :style="$common.labelStyle('人员名称')" v-html="'人员名称'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmName" placeholder="请输入人员名称" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="助记码" prop="opmMne">
                                                    <label slot="label" :style="$common.labelStyle('助记码')" v-html="'助记码'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmMne" placeholder="请输入人员名称" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="手机号" prop="opmMobilenumber">
                                                    <label slot="label" :style="$common.labelStyle('手机号')" v-html="'手机号'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmMobilenumber" placeholder="请输入手机号" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="身份证号" prop="opmIdnumber">
                                                    <label slot="label" :style="$common.labelStyle('身份证号')" v-html="'身份证号'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmIdnumber" placeholder="请输入身份证号" maxlength="18">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="身份证有效期" prop="opmPeriodDate">
                                                    <label slot="label" :style="$common.labelStyle('身份证有效期')" v-html="'身份证有效期'"></label>
                                                    <el-date-picker style="width: 100%;" value-format="timestamp" v-model="sendDataInfo.opmPeriodDate" type="date" placeholder="选择日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="12">
                                                <el-form-item label="登录账号" prop="opmAccount" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                    <label slot="label" :style="$common.labelStyle('登录账号')" v-html="'登录账号'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmAccount" :maxlength="$store.state.inputLength" placeholder="请输入登录账号"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="登录密码" prop="opmPassword" v-if="dataActionBox.actionType == 0" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                    <label slot="label" :style="$common.labelStyle('登录密码')" v-html="'登录密码'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmPassword" :maxlength="$store.state.inputLength" placeholder="请输入登录密码"></el-input>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="12">
                                                <el-form-item label="邮箱">
                                                    <label slot="label" :style="$common.labelStyle('邮箱')" v-html="'邮箱'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmEmail" :maxlength="$store.state.inputLength" placeholder="请输入联系邮箱"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="固话">
                                                    <label slot="label" :style="$common.labelStyle('固话')" v-html="'固话'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmTelenumber" :maxlength="$store.state.inputLength" placeholder="请输入联系固话"></el-input>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="12">
                                                <el-form-item label="岗位" prop="opmJob">
                                                    <label slot="label" :style="$common.labelStyle('岗位')" v-html="'岗位'"></label>
                                                    <el-input v-model.trim="sendDataInfo.opmJob" placeholder="请输入岗位" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="班次" prop="banCi">
                                                    <label slot="label" :style="$common.labelStyle('班次')" v-html="'班次'"></label>
                                                    <el-input v-model.trim="sendDataInfo.banCi" placeholder="请输入班次" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-form-item label="身份证正反面">
                                                <label slot="label" :style="$common.labelStyle('身份证正反面')" v-html="'身份证正反面'"></label>
                                                <el-upload ref="upload" :action="$store.getters.getConfig.requestUrl + '/upload/fileupload'" :headers="token" :file-list="fileList" list-type="picture-card"
                                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess">
                                                    <i class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-dialog :visible.sync="dialogVisible">
                                                    <img width="100%" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </el-form-item>

                                        </el-row>
                                        <el-row>
                                            <el-col :span="6">
                                                <el-form-item label="性别">
                                                    <label slot="label" :style="$common.labelStyle('性别')" v-html="'性别'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmSex">
                                                        <el-radio-button v-for="item in dictionariesData" :key="item.diId" :label="item.diValue">{{
                                                                item.diValue }}</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否收货人">
                                                    <label slot="label" :style="$common.labelStyle('是否收货人')" v-html="'是否收货人'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmDelivery" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否超管">
                                                    <label slot="label" :style="$common.labelStyle('是否超管')" v-html="'是否超管'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmAdmin" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否验收人">
                                                    <label slot="label" :style="$common.labelStyle('是否验收人')" v-html="'是否验收人'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmAcceptor" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否采购员">
                                                    <label slot="label" :style="$common.labelStyle('是否采购员')" v-html="'是否采购员'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmBuyer" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否收款人">
                                                    <label slot="label" :style="$common.labelStyle('是否收款人')" v-html="'是否收款人'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmCashier" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否配送员">
                                                    <label slot="label" :style="$common.labelStyle('是否配送员')" v-html="'是否配送员'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmDistributor" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否医师">
                                                    <label slot="label" :style="$common.labelStyle('是否医师')" v-html="'是否医师'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmDoctor" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否司机">
                                                    <label slot="label" :style="$common.labelStyle('是否司机')" v-html="'是否司机'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmDriver" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否部门主管">
                                                    <label slot="label" :style="$common.labelStyle('是否部门主管')" v-html="'是否部门主管'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmHeader" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否总经理">
                                                    <label slot="label" :style="$common.labelStyle('是否总经理')" v-html="'是否总经理'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmGm" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否保管员">
                                                    <label slot="label" :style="$common.labelStyle('是否保管员')" v-html="'是否保管员'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmKeeper" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否执业药师">
                                                    <label slot="label" :style="$common.labelStyle('是否执业药师')" v-html="'是否执业药师'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmPharmacist" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否复核人">
                                                    <label slot="label" :style="$common.labelStyle('是否复核人')" v-html="'是否复核人'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmReviewer" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否修改单价"> 
                                                    <label slot="label" :style="$common.labelStyle('是否修改单价')" v-html="'是否修改单价'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmStore" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否销售员">
                                                    <label slot="label" :style="$common.labelStyle('是否销售员')" v-html="'是否销售员'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmSalesperson" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否特药">
                                                    <label slot="label" :style="$common.labelStyle('是否特药')" v-html="'是否特药'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmSpc" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否价格特权">
                                                    <label slot="label" :style="$common.labelStyle('是否价格特权')" v-html="'是否价格特权'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmPrice" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否允许导出">
                                                    <label slot="label" :style="$common.labelStyle('是否允许导出')" v-html="'是否允许导出'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmExport" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否打印">
                                                    <label slot="label" :style="$common.labelStyle('是否打印')" v-html="'是否打印'"></label>
                                                    <el-radio-group v-model="sendDataInfo.isPrint" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否允许多设备登录">
                                                    <label slot="label" :style="$common.labelStyle('是否允许多设备登录')" v-html="'是否允许多设备登录'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmSitelogin" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否订单特权">
                                                    <label slot="label" :style="$common.labelStyle('是否订单特权')" v-html="'是否订单特权'"></label>
                                                    <el-radio-group v-model="sendDataInfo.opmOrder" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item label="是否展示流程图">
                                                    <label slot="label" :style="$common.labelStyle('是否展示流程图')" v-html="'是否展示流程图'"></label>
                                                    <el-radio-group v-model="sendDataInfo.isShowFlow" size="mini">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "userAction",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            showTabs: '',
            formDataList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                opmCode: "", // 人员编码
                opgId: "", // 人员分组
                depId: "", // 部门ID
                opmJob: '',
                banCi: '',//班次
                opmName: "", // 姓名
                opmMne: "",
                opmPassword: "", // 密码
                opmMobilenumber: "", // 手机号
                opmIdnumber: "", // 身份证号
                opmPeriodDate: '',// 身份证有效期
                opmEmail: "", // 邮箱
                opmPhoto: "", // 照片
                opmTelenumber: "", // 固话
                opmAccount: "", // 登录账号
                opmDelivery: 0,//是否收货人
                opmBuyer: 0, // 是否采购员
                opmAcceptor: 0, // 是否验收人
                opmCashier: 0, // 是否收款人
                opmDistributor: 0, // 是否配送员
                opmDoctor: 0, // 是否医师
                opmDriver: 0, // 是否司机
                opmHeader: 0, // 是否部门主管
                opmKeeper: 0, // 是否保管员
                opmPharmacist: 0, // 是否执业药师
                opmReviewer: 0, // 是否复核人
                opmStore: 0, // 是否允许修改单价
                opmSalesperson: 0, // 是否销售员
                opmSex: '', // 性别
                opmAdmin: 0, // 是否超级管理员
                opmId: "",
                opmSpc: 0, //是否特药
                opmPrice: 0, //是否价格特权
                opmOrder: 0,//是否订单特权
                isShowFlow:1,//是否展示流程图
                opmGm: 0,//是否总经理
                // ormIds: [],
                opmSitelogin: 0, //是否允许多设备登录
                opmType: 0,
                isPrint: 1,
                opmExport: 1,
                uploadVoList: []
            },
            defaultProps: {
                multiple: true,
                expandTrigger: 'hover',
                checkStrictly: true,
                emitPath: false,
            },
            fileList: [],
            allorgList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            selectedDataList: [],
            departmentList: [],
            customertype: [{
                lable: 0,
                name: "普通用户",
            },
            {
                lable: 1,
                name: "货主用户",
            },
            ],
            dictionariesData: [], //男女字典

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.opmName"() {
            //获取助记码
            this.sendDataInfo.opmMne = this.$common.createPinyinCode(
                this.sendDataInfo.opmName,this.sendDataInfo.opmMne
            );
        },
    },
    //方法集合
    methods: {
        handleRemove(file, fileList) {
            file = file.url.split(this.$store.getters.getConfig.requestUrl + "/")[1]
            console.log(file, this.sendDataInfo.uploadVoList);
            this.sendDataInfo.uploadVoList.splice(this.sendDataInfo.uploadVoList.findIndex(item => item.fileUrl == file), 1)
        },
        beforeClose() {
            this.$refs.upload.clearFiles()
            this.dataActionBox.showStatus = false
        },
        handleSuccess(response, file, fileList) {
            console.log(fileList);
            if (this.sendDataInfo.uploadVoList == '') {
                this.sendDataInfo.uploadVoList = []
            }
            this.sendDataInfo.uploadVoList.push(response.result[0])
        },
        cancel() {
            this.dataActionBox.showStatus = false
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
        ,
        // 获取全部组织
        // async getOrgList() {
        // 	var _this = this
        // 	this.allorgList = await this.$common.getALLOrg()
        // 	if (this.allorgList.length >= 1) {
        // 		_this.sendDataInfo.ormIds = []
        // 		var responseData = await this.$http.getUserOrg({
        // 			ids: [this.sendDataInfo.opmId]
        // 		})
        // 		if (responseData.status == 200) {
        // 			console.log(responseData.result)
        // 			if (responseData.result.length >= 1) {
        // 				responseData.result.forEach(item => {
        // 					_this.sendDataInfo.ormIds.push(item.ormId)
        // 				})
        // 			}
        // 		} else {
        // 			this.$message({
        // 				message: responseData.message,
        // 				type: 'error'
        // 			});
        // 		}
        // 	}
        // },

        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            // 如果配置了新增用户默认密码，则自动填充
            if (window.global_config && window.global_config.defaultUserPassword) {
                this.sendDataInfo.opmPassword = window.global_config.defaultUserPassword;
            }
            this.sendDataInfo.opmCode = this.$common.createUserCode();
            this.sendDataInfo.opmAcceptor = 0;
            this.sendDataInfo.opmBuyer = 0;
            this.sendDataInfo.opmDelivery = 0;
            this.sendDataInfo.opmCashier = 0;
            this.sendDataInfo.opmDoctor = 0;
            this.sendDataInfo.opmHeader = 0;
            this.sendDataInfo.opmKeeper = 0;
            this.sendDataInfo.opmPharmacist = 0;
            this.sendDataInfo.opmReviewer = 0;
            this.sendDataInfo.opmStore = 0;
            this.sendDataInfo.opmSalesperson = 0;
            this.sendDataInfo.opmSex = '男';
            this.sendDataInfo.opmAdmin = 0;
            this.sendDataInfo.opmJob = '';
            this.sendDataInfo.banCi = '';
            this.sendDataInfo.opmDriver = 0;
            this.sendDataInfo.opmDistributor = 0;
            this.sendDataInfo.opmSpc = 0;
            this.sendDataInfo.opmPrice = 0;
            this.sendDataInfo.opmOrder = 0;
            this.sendDataInfo.isShowFlow = 1;
            this.sendDataInfo.opmSitelogin = 0;
            this.sendDataInfo.isPrint = 1;
            this.sendDataInfo.opmExport = 1;
            // this.sendDataInfo.ormIds = []

            this.selectDepartmentPath = "";
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        async openBox(cate, departmentList, oldData = "") {
            this.fileList = []
            this.departmentList = departmentList;
            console.log(this.departmentList);
            if (cate == 0) {
                this.initActionBox();
                this.dataActionBox.boxTitle = "新增信息";
                this.showTabs = "新增人员"
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.uploadVoList = []
                this.formDataList = [
                    {
                        jciName: "新增人员",
                        jurconfigform: [],
                    }
                ]
            } else {

                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "ltr";
                this.showTabs = "编辑人员"
                this.formDataList = [
                    {
                        jciName: "编辑人员",
                        jurconfigform: [],
                    }
                ]
                console.log(oldData)
                for (let key in oldData) {
                    this.sendDataInfo[key] = oldData[key];
                }
                let res = await this.$http.queryUploadVo({ ids: [this.sendDataInfo.opmId] })
                this.sendDataInfo.uploadVoList = res.result
                if (this.sendDataInfo.uploadVoList.length > 0) {
                    this.fileList = this.sendDataInfo.uploadVoList.map(item => {
                        return {
                            'name': item.fileName,
                            'url': this.$store.getters.getConfig.imgUrl + "/" + item.fileUrl
                        }
                    })
                }
                this.sendDataInfo.ormId = JSON.parse(JSON.stringify(oldData.ormId))
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },

        sendDataAction(sendDataInfo) {

            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addUser(sendDataInfo);
            } else {
                var responseData = await this.$http.editUser(sendDataInfo);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });

                this.$parent.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [1],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "字典项获取失败",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPartDictionariesData();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_box {
    padding-bottom:50px;
}
</style>